<template>
  <div>
    <ur-modal ref="modal" @closed="closedModel" draggable>
      <span>You are Logged out!!!</span>
      <template slot="action">
        <ur-button @click="onClickOK" main>Okay</ur-button>
      </template>
    </ur-modal>
  </div>
</template>

<script>
import AuthService from "../../services/AuthService";
import { mapActions, mapGetters } from "vuex";
export default {
  data: function () {
    return {
      events: ["click", "mousemove", "mousedown", "scroll", "keypress", "load"],
      warningTimer: null,
      logoutTimer: null,
      countTimer: null,
      warningZone: false,
      initalCounter: 1800000,
      counter: 1800000,
    };
  },
  computed: {
    ...mapGetters(["getUserInfo"]),
    getDiff() {
      return this.counter - this.initalCounter;
    },
  },
  mounted() {
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);

    this.setTimers();
  },

  destroyed() {
    this.events.forEach(function (event) {
      window.addEventListener(event, this.resetTimer);
    }, this);
    this.resetTimer();
  },

  methods: {
    ...mapActions(["DMSLogOutAction",]),
    setTimers: function () {
      if (localStorage.getItem("token")) {
        this.warningTimer = setTimeout(
          this.warningMessage,
          this.initalCounter * 1000
        );
        this.logoutTimer = setTimeout(this.logoutUser, 1740000);
        this.countTimer = setTimeout(this.countDown, 1740000);
      }
      this.warningZone = false;
    },
    warningMessage: function () {
      this.warningZone = true;
    },
    countDown: function () {
      this.counter--;
      if (this.counter > 0) {
        setTimeout(this.countDown, 1000);
      }
      this.counter;
    },

    logoutUser: async function () {
      this.$refs.modal.open();
      let tokenIndex = localStorage.getItem("token").indexOf(" ");
      const payload = {
        token: localStorage.getItem("token").substring(tokenIndex + 1),
        username: this.getUserInfo.userCd,
        logoffType: "Timeout"
      };
      this.DMSLogOutAction(payload)
        .then((res) => {})
        .catch((err) => {});    
      AuthService.doLogout(false);
    },

    resetTimer: function () {
      clearTimeout(this.warningTimer);
      clearTimeout(this.logoutTimer);
      clearTimeout(this.countTimer);

      this.setTimers();
    },
    onClickOK: function () {
      this.$refs.modal.close();
      AuthService.doLogout();
    },
    closedModel: function(){
      AuthService.doLogout();
    }
  },
};
</script>
